import { Component,Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TranscriptionCreateService } from '../transcription-create.service';
import * as global from '../../global';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as moment from 'moment';
import { NoteEditorService } from '../../note-editor/note-editor.service';
import { Note } from '../../note-editor/model/note';
import { TranscriptionService } from 'src/app/services/transcription.service';
import { AuthService } from 'src/app/services/auth.service';
import { HttpResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
// UPLOAD FILE DIALOG
export interface ViewNoteDialog {
  note
  timezone:any,
  void_census: any
}

@Component({
  selector: 'app-view-note-dialog',
  templateUrl: './view-note-dialog.component.html',
  styleUrls: ['./view-note-dialog.component.css']
})
export class ViewNoteDialog implements OnInit {
  global = global;
  
  note;
  note_id:string;
  height:number;
  loaderId = 'view-note-loader';
  addendums:any[];
  timezone;
  currentUser: any;
  voidCensus: Boolean  = true;
  dontShowPreview: Boolean;
  readOnly: any;
  isNurseUser: boolean = false;
  company_id: any;
  routerLink: any;

  constructor(
    public dialogRef: MatDialogRef<ViewNoteDialog>,
    // private loader: NgxUiLoaderService,
    private noteEditorService:NoteEditorService,
    private transcriptionService:TranscriptionService,
    private transcriptionCreateService:TranscriptionCreateService,
    private _auth: AuthService,
    private _router: Router,
    private route: ActivatedRoute,

    @Inject(MAT_DIALOG_DATA) public data: ViewNoteDialog) { 
      if(data) {
        this.note = data.note;
        this.note_id = data.note_id;
        this.timezone = data.timezone;
        this.readOnly = data.readOnly;
        if(!(data.void_census)){
          this.voidCensus = false;
        }
      }
    }
    
    async ngOnInit() {
            
      if (this.note_id) {
        const noteResponse: any = await this.transcriptionService.get_transcription_by_id(this.note_id).toPromise();
        if (noteResponse.status === 200) {
          this.note = noteResponse.data;
        }
      }
      this.currentUser = this._auth.currentUser;
      if (this.currentUser.user_type.toLowerCase() === 'nurse') {
        this.isNurseUser = true;
      }
      this.initAddendums();
      if (this._router.url.includes("/company")) {
        let company_id = this.route.snapshot.firstChild.params.id;
        this.routerLink = `company/${company_id ? company_id : this.currentUser.company_id}/note-editor/${this.note._id}`;
      } else
        this.routerLink = `/note-editor/${this.note._id}`;
    }

    initAddendums() {
      this.transcriptionCreateService.getNoteAddendums({noteId: this.note._id}).subscribe((response:any) => {
        if (response.status === 200) {
          this.addendums = response.data.array;
          this.height=80;
        }
      });
    }


    applyTimezone(date) {

      let serviceDate = new Date(new Date(date).toLocaleString('en-US', { timeZone: this.timezone }))

      return serviceDate;
      // return moment(new Date(date)).format('MMM DD, YYYY h:mm a');
     
      // return moment(new Date(date).toLocaleString('en-US', { timeZone:  this.note.filterServiceDate.timezone })).format('MMM DD, YYYY h:mm a');
    }

    generatePDFNote() {
      this.noteEditorService.generatePDFNote(this.note._id,this.currentUser.company_id).subscribe((res: any) => {
          if (res instanceof HttpResponse) {
              var url = window.URL.createObjectURL(res.body);
              var a = document.createElement('a');
              document.body.appendChild(a);
              a.setAttribute('style', 'display: none');
              a.href = url;
              a.download = `${this.note.transcribtion_title}.pdf`;
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove(); // remove the element
          }
      });
  }
  getDOS() {
    let {year, month, day, hour, minute} = this.note.date_obj;
    if(month < 10){
        month = '0' + month;
    }
    if(day < 10){
        day = '0' + day;
    }
    let str = `${month}/${day}/${year}`;
    if(hour && minute) {
        str += ` ${hour}:${minute}`
    }
    return str;
  }

  getAddendumDate(addendum) {
    if (addendum.created_date_obj) {
      let {year, month, day, hour, minute} = addendum.created_date_obj;
      if (month < 10) {
          month = '0' + month;
      }
      if (day < 10) {
          day = '0' + day;
      }
      let str = `${month}/${day}/${year}`;
      if (hour && minute) {
          str += ` ${hour}:${minute}`
      }
      return str;
    } else {
      return moment(this.applyTimezone(addendum.createdAt)).format(global.moment_date_format2)
    }
  }

  async updateOtherSettings() {
    let updatePromise = Promise.resolve();

    if ( this.dontShowPreview ) {
      const settingKey = 'preview_note';

      const otherSettings = {
        [ settingKey ]: typeof this._auth.currentUser.other_settings[ settingKey ] === 'boolean' ? !this._auth.currentUser.other_settings[ settingKey ] : false
      }
  
      updatePromise = this._auth.setOtherUserSettings( otherSettings ).toPromise();
    }

    await updatePromise;
  }
}
